import { render, staticRenderFns } from "./StockSubscriptionForm.vue?vue&type=template&id=c8ce519e&scoped=true"
import script from "./StockSubscriptionForm.vue?vue&type=script&lang=ts"
export * from "./StockSubscriptionForm.vue?vue&type=script&lang=ts"
import style0 from "./StockSubscriptionForm.vue?vue&type=style&index=0&id=c8ce519e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ce519e",
  null
  
)

export default component.exports